import React, { useState } from "react";
import tableup from "../../../../assets/tableup.svg";
import tabledown from "../../../../assets/tabledown.svg";
import { format } from "date-fns";
import { toast } from "react-toastify";
import ReactPaginate from "react-paginate";

const DataTable = ({ users = [], toggleUserStatus, pagination, onPageChange }) => {
  const [sortField, setSortField] = useState("createdAt");
  const [sortDirection, setSortDirection] = useState(1); // 1 for asc, -1 for desc

  const handleSort = (field) => {
    if (sortField === field) {
      // Toggle direction if same field
      setSortDirection(sortDirection === 1 ? -1 : 1);
    } else {
      // New field, default to ascending
      setSortField(field);
      setSortDirection(1);
    }

    // You can implement sorting on the server side by calling the API again
    // or handle it on the frontend if you have all data
  };

  const handleToggleStatus = (userId, currentStatus) => {
    toggleUserStatus(userId);
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text)
      .then(() => {
        toast.success("Email copied to clipboard");
      })
      .catch((err) => {
        toast.error("Failed to copy email");
        console.error("Failed to copy: ", err);
      });
  };

  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      return {
        date: format(date, "MM/dd/yyyy"),
        time: format(date, "H:mm")
      };
    } catch (e) {
      return { date: "N/A", time: "N/A" };
    }
  };
  const renderPagination = () => {
    if (!pagination || pagination.totalPages <= 1) return null;

    const handlePageChange = (event) => {
      onPageChange(event.selected + 1); // ReactPaginate's page index is 0-based
    };

    return (
           <div className="footer-content">
           <div className="left-f">
              {/* <h6>SHOWING 1-10 OF 145</h6> */}
              {/* <h6>SHOWING 1-10 OF 145</h6> */}
            </div>
      <div className="right-f">
        <nav aria-label="Page navigation example">
          <ul className="pagination">
            <ReactPaginate
              previousLabel={
               <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M12.6667 8L3.33335 8" stroke="#042B33" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8 3.33317L3.33333 7.99984L8 12.6665" stroke="#042B33" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
              }
              nextLabel={
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M3.33331 8L12.6666 8" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8 3.33317L12.6667 7.99984L8 12.6665" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
              }
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              pageCount={pagination.totalPages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageChange}
              containerClassName="pagination"
              activeClassName="active"
              forcePage={pagination.currentPage - 1} // ReactPaginate's page index is 0-based
            />
          </ul>
        </nav>
      </div>
      </div>
    );
  };
  // const renderPagination = () => {
  //   if (!pagination || pagination.totalPages <= 1) return null;

  //   const pages = [];
  //   for (let i = 1; i <= pagination.totalPages; i++) {
  //     pages.push(
  //       <button
  //         key={i}
  //         className={`pagination-btn ${pagination.currentPage === i ? 'active' : ''}`}
  //         onClick={() => onPageChange(i)}
  //       >
  //         {i}
  //       </button>
  //     );
  //   }

  //   return (
  //     <div className="pagination-container">
  //       <button
  //         className="pagination-btn prev"
  //         disabled={pagination.currentPage === 1}
  //         onClick={() => onPageChange(pagination.currentPage - 1)}
  //       >
  //         &lt;
  //       </button>
  //       {pages}
  //       <button
  //         className="pagination-btn next"
  //         disabled={pagination.currentPage === pagination.totalPages}
  //         onClick={() => onPageChange(pagination.currentPage + 1)}
  //       >
  //         &gt;
  //       </button>
  //     </div>
  //   );
  // };

  return (
    <>
      <section className="datatable">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>
                  <div
                    className="parent-tag"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleSort("createdAt")}
                  >
                    Date Added
                    {/* <div className="filter-btn">
                      <svg
                        width="9"
                        height="6"
                        viewBox="0 0 9 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.90908 5.14282H4.09498H0.660442C0.072714 5.14282 -0.22115 4.36222 0.195157 3.90463L3.36644 0.418863C3.87458 -0.139668 4.70107 -0.139668 5.20921 0.418863L6.41528 1.74453L8.38049 3.90463C8.79068 4.36222 8.49681 5.14282 7.90908 5.14282Z"
                          fill={sortField === "createdAt" && sortDirection === 1 ? "#000" : "#77868B"}
                        />
                      </svg>
                      <svg
                        width="9"
                        height="6"
                        viewBox="0 0 9 6"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.90908 0.857178H4.09498H0.660442C0.072714 0.857178 -0.22115 1.63778 0.195157 2.09537L3.36644 5.58114C3.87458 6.13967 4.70107 6.13967 5.20921 5.58114L6.41528 4.25547L8.38049 2.09537C8.79068 1.63778 8.49681 0.857178 7.90908 0.857178Z"
                          fill={sortField === "createdAt" && sortDirection === -1 ? "#000" : "#77868B"}
                        />
                      </svg>
                    </div> */}
                  </div>
                </th>
                <th>
                  <div
                    className="parent-tag"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleSort("email")}
                  >
                    Email
                    
                  </div>
                </th>
                <th>
                  <div
                    className="parent-tag"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleSort("name")}
                  >
                    Name
                    
                  </div>
                </th>
                <th>
                  <div
                    className="parent-tag"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleSort("adminAccess")}
                  >
                    Access Level
                  
                  </div>
                </th>
                <th>
                  <div className="parent-tag">
                    Activate/Deactivate
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {users.length > 0 ? (
                users.map((user) => {
                  const formattedDate = formatDate(user.createdAt);
                  return (
                    <tr key={user._id}>
                      <td>
                        <div className="twice-text">
                          <h6>{formattedDate.date}</h6>
                          <p>{formattedDate.time}</p>
                        </div>
                      </td>
                      <td>
                        {user.email}
                        <a href="#" onClick={(e) => {
                          e.preventDefault();
                          copyToClipboard(user.email);
                        }}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
                            <path d="M9.41377 8.49985L9.44015 10.9497C9.46213 12.9913 8.65431 13.8167 6.61276 13.8386L4.1629 13.865C2.12135 13.887 1.29594 13.0792 1.27396 11.0376L1.24757 8.58778C1.22559 6.54623 2.03342 5.72082 4.07496 5.69884L6.52482 5.67246C8.56637 5.65047 9.39178 6.4583 9.41377 8.49985Z" stroke="#77868B" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M12.8762 4.96235L12.9026 7.41221C12.9245 9.45376 12.1167 10.2792 10.0752 10.3012L9.43353 10.3081L9.41406 8.49984C9.39208 6.45829 8.56666 5.65046 6.52512 5.67245L4.71689 5.69192L4.70998 5.05029C4.68799 3.00874 5.49582 2.18333 7.53737 2.16135L9.98723 2.13496C12.0288 2.11298 12.8542 2.92081 12.8762 4.96235Z" stroke="#77868B" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </a>
                      </td>
                      <td>{user.name}</td>
                      <td>{user.adminAccess === "READ" ? "Read Only" : "Read & Write"}</td>
                      <td>
                        <div className="parent-toggle-switch-custom">
                          <div className="custom-toggle">
                            <input
                              type="checkbox"
                              className="checkbox"
                              id={`toggle-${user._id}`}
                              checked={user.isActiveAdmin === true}
                              onChange={() => handleToggleStatus(user._id, user.isActiveAdmin)}
                            />
                            <label className="switch red" htmlFor={`toggle-${user._id}`}>
                              <span className="slider"></span>
                            </label>
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="5" className="text-center">
                    No users found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          {renderPagination()}
        </div>
      </section>
      
    </>
  );
};

export default DataTable;